const MY_BAIRROS_KEY = "vigial_my_bairros_v1";
const BAIRRO_REPORT_UNLOCK_KEY = "vigial_bairro_report_unlock_v1";
const FREE_BAIRRO_LIMIT = 1;
const PREMIUM_BAIRRO_LIMIT = 3;
const MB_API_BASE = "https://alerta-maceio-api-production.up.railway.app/api";
const MB_WEEK_MS = 7 * 24 * 3600 * 1000;

// Custom badge artwork per bairro (commissioned separately, see
// bairro-symbols/ next to this file) — drawn on the shareable weekly-summary
// card when one exists for that bairro. No entry yet = the card just omits
// the badge rather than falling back to a generic/wrong placeholder.
const BAIRRO_SYMBOL_FILES = {
  "Pontal da Barra": "pontalsymbol.webp",
  "Farol": "farolsymbol.webp",
  "Riacho Doce": "riachodocesymbol.webp",
  "Jaraguá": "jaraguasymbol.webp",
  "Ponta Verde": "pontaverdesymbol.webp",
  "Benedito Bentes": "beneditobentessymbol.webp",
  "Centro": "centrosymbol.webp",
  "Cruz das Almas": "cruzdasalmassymbol.webp",
  "Jatiúca": "jatiucasymbol.webp",
  "Mangabeiras": "mangabeirassymbol.webp",
  "Poço": "posymbol.webp",
  "Trapiche da Barra": "trapichesymbol.webp",
  "Bebedouro": "bebedourosymbol.webp",
  "Bom Parto": "bompartosymbol.webp",
  "Cidade Universitária": "cidadeuniversitariasymbol.webp",
  "Fernão Velho": "fernaovelhosymbol.webp",
  "Gruta de Lourdes": "grutasymbol.webp",
  "Jacarecica": "jacarecicasymbol.webp",
  "Levada": "levadasymbol.webp",
  "Mutange": "mutangesymbol.webp",
  "Pajuçara": "pajucarasymbol.webp",
  "Pitanguinha": "pitanguinhasymbol.webp",
  "Prado": "pradosymbol.webp",
  "Rio Novo": "rionovosymbol.webp",
  "Santa Amélia": "santaameliasymbol.webp",
  "Serraria": "serrariasymbol.webp",
  "Petrópolis": "petropolissymbol.webp",
};

function loadMyBairros() {
  try { return JSON.parse(localStorage.getItem(MY_BAIRROS_KEY) || "[]"); } catch (e) { return []; }
}
function saveMyBairros(list) {
  try { localStorage.setItem(MY_BAIRROS_KEY, JSON.stringify(list)); } catch (e) {}
  if (window.pushAccountSync) window.pushAccountSync({ myBairros: list });
}
function loadUnlockedWeeks() {
  try { return JSON.parse(localStorage.getItem(BAIRRO_REPORT_UNLOCK_KEY) || "{}"); } catch (e) { return {}; }
}
function saveUnlockedWeeks(obj) {
  try { localStorage.setItem(BAIRRO_REPORT_UNLOCK_KEY, JSON.stringify(obj)); } catch (e) {}
}
function isoWeekKey(d) {
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const dayNum = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
  return `${date.getUTCFullYear()}-W${weekNo}`;
}
function stripAccentsMB(s) {
  const norm = (s || "").normalize("NFD");
  let out = "";
  for (let i = 0; i < norm.length; i++) {
    const code = norm.charCodeAt(i);
    if (code < 0x0300 || code > 0x036f) out += norm[i];
  }
  return out.toLowerCase();
}
function bboxCenterAndRadius(ring) {
  const lons = ring.map((p) => p[0]);
  const lats = ring.map((p) => p[1]);
  const minLon = Math.min(...lons), maxLon = Math.max(...lons);
  const minLat = Math.min(...lats), maxLat = Math.max(...lats);
  const cLat = (minLat + maxLat) / 2;
  const cLng = (minLon + maxLon) / 2;
  const dLat = (maxLat - minLat) * 111000;
  const dLng = (maxLon - minLon) * 111000 * Math.cos((cLat * Math.PI) / 180);
  const radius = Math.min(3000, Math.max(400, (Math.hypot(dLat, dLng) / 2) * 1.15));
  return { lat: cLat, lng: cLng, radius: Math.round(radius) };
}
function getOrCreateDeviceIdMB() {
  try {
    let id = localStorage.getItem("vigial_device_id");
    if (!id) { id = window.generateStrongDeviceId ? window.generateStrongDeviceId() : "d" + Date.now() + Math.random().toString(36).slice(2); localStorage.setItem("vigial_device_id", id); }
    return id;
  } catch (e) { return "anon"; }
}
async function syncBairroPushPlaces(mergedPlaces) {
  try {
    if (!("serviceWorker" in navigator)) return;
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    await fetch(`${MB_API_BASE}/push/subscribe`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ deviceId: getOrCreateDeviceIdMB(), subscription: sub.toJSON(), places: mergedPlaces, sensitivity: "all" }),
    });
  } catch (e) {}
}
// Registered bairros ride the same point+radius push pipeline as "meu local
// protegido" (a circle around the bairro's bounding box), so no backend
// changes are needed - just keep the shared places list in sync.
function persistBairroPlaces(myBairros, bairroGeo) {
  const key = window.PLACES_KEY || "vigial_saved_places_v1";
  let existing = [];
  try { existing = JSON.parse(localStorage.getItem(key) || "[]"); } catch (e) {}
  const pointPlaces = existing.filter((p) => !p.isBairro);
  const bairroPlaces = myBairros
    .map((name) => {
      const geo = bairroGeo[name];
      return geo ? { id: "bairro_" + name, name, lat: geo.lat, lng: geo.lng, radius: geo.radius, isBairro: true } : null;
    })
    .filter(Boolean);
  const merged = [...pointPlaces, ...bairroPlaces];
  try { localStorage.setItem(key, JSON.stringify(merged)); } catch (e) {}
  syncBairroPushPlaces(merged);
  if (window.pushAccountSync) window.pushAccountSync({ places: merged });
}

function loadImageEl(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

// Lucide icons ship as stroke="currentColor" line art — an <img> tag can't
// resolve currentColor (there's no CSS `color` context for an externally
// referenced image), which is exactly why the map's own pins use a CSS
// mask-image instead of drawing the SVG directly. Canvas has no mask-image
// equivalent, so this recolors the raw SVG text before turning it into an
// image, same trick the press kit's build script uses. ski-mask.svg (this
// app's own icon) is a bare filled path with no currentColor convention at
// all, so it needs `fill` set on the root instead.
async function loadColoredIconImage(iconName, color) {
  const url = window.catIconUrl ? window.catIconUrl(iconName) : `https://unpkg.com/lucide-static@0.462.0/icons/${iconName}.svg`;
  const resp = await fetch(url);
  let svg = await resp.text();
  svg = iconName === "ski-mask" ? svg.replace("<svg", `<svg fill="${color}"`) : svg.replaceAll("currentColor", color);
  const objUrl = URL.createObjectURL(new Blob([svg], { type: "image/svg+xml" }));
  try {
    return await loadImageEl(objUrl);
  } finally {
    URL.revokeObjectURL(objUrl);
  }
}

// Renders the weekly bairro summary as a 1080x1920 (Stories-ratio) PNG and
// hands it to the OS share sheet — this is the app's main organic growth
// loop, so it deliberately mirrors the press kit's dark navy/red/amber
// palette rather than pulling CSS vars (canvas can't read custom properties,
// and this needs to render identically regardless of the page's own theme).
async function shareBairroCard({ bairroName, thisTotal, delta, lastTotal, topCats, lang }) {
  const W = 1080, H = 1920;
  const NAVY = "#0A1420", SURFACE = "#101E31", BORDER = "#223349";
  const TXT = "#EAF0F8", TXT2 = "#A7B7C9", TXT3 = "#71879C";
  const RED = "#DA3A3A", BRAND = "#5C8DD0", AMBER = "#C4841E";
  const TONE_COLOR = { alert: "#C81E2C", warning: "#C4841E", neutral: "#5C6B77" };

  const catsToShow = topCats.slice(0, 4);
  const catIcons = await Promise.all(
    catsToShow.map(async (c) => {
      const color = TONE_COLOR[c.tone] || TONE_COLOR.neutral;
      try {
        return await loadColoredIconImage(c.icon, color);
      } catch (e) {
        return null;
      }
    })
  );

  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext("2d");

  const bg = ctx.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, "#0F1B2E");
  bg.addColorStop(0.55, NAVY);
  bg.addColorStop(1, "#060B14");
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(W * 0.8, 260, 40, W * 0.8, 260, 620);
  glow.addColorStop(0, "rgba(200,30,44,0.22)");
  glow.addColorStop(1, "rgba(200,30,44,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);

  try {
    const logo = await loadImageEl("logo.png");
    ctx.save();
    ctx.beginPath();
    ctx.roundRect(80, 96, 84, 84, 20);
    ctx.clip();
    ctx.drawImage(logo, 80, 96, 84, 84);
    ctx.restore();
  } catch (e) {}

  ctx.fillStyle = TXT;
  ctx.font = "700 34px 'Segoe UI', Arial, sans-serif";
  ctx.textBaseline = "middle";
  ctx.fillText("Alerta AL", 186, 138);

  ctx.fillStyle = RED;
  ctx.beginPath();
  ctx.arc(80, 258, 7, 0, Math.PI * 2);
  ctx.fill();
  ctx.font = "700 26px 'Segoe UI', Arial, sans-serif";
  ctx.fillStyle = RED;
  ctx.textBaseline = "alphabetic";
  ctx.fillText(t(lang, "shareCardEyebrow").toUpperCase(), 102, 268);

  ctx.fillStyle = TXT;
  ctx.font = "800 88px 'Segoe UI', Arial, sans-serif";
  wrapText(ctx, bairroName, 80, 400, W - 160, 92);

  const symbolFile = BAIRRO_SYMBOL_FILES[bairroName];
  if (symbolFile) {
    try {
      const symbol = await loadImageEl(`bairro-symbols/${symbolFile}`);
      const SIZE = 460, sx = W - 80 - SIZE, sy = 470;
      ctx.drawImage(symbol, sx, sy, SIZE, SIZE);
    } catch (e) {}
  }

  ctx.font = "900 220px 'Segoe UI', Arial, sans-serif";
  ctx.fillStyle = TXT;
  ctx.fillText(String(thisTotal), 80, 780);
  const numWidth = ctx.measureText(String(thisTotal)).width;
  ctx.font = "500 34px 'Segoe UI', Arial, sans-serif";
  ctx.fillStyle = TXT2;
  wrapText(ctx, t(lang, "occurrencesThisWeek"), 80, 840, W - 160, 42);

  if (lastTotal > 0) {
    const up = delta > 0;
    const flat = delta === 0;
    const deltaColor = flat ? TXT3 : up ? RED : BRAND;
    const arrow = flat ? "—" : up ? "▲" : "▼";
    const deltaText = `${arrow}  ${Math.abs(delta)} ${t(lang, "vsLastWeek")}`;
    ctx.font = "700 36px 'Segoe UI', Arial, sans-serif";
    const pillW = ctx.measureText(deltaText).width + 56;
    ctx.fillStyle = deltaColor + "22";
    ctx.strokeStyle = deltaColor + "55";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.roundRect(80, 900, pillW, 62, 31);
    ctx.fill();
    ctx.stroke();
    ctx.fillStyle = deltaColor;
    ctx.textBaseline = "middle";
    ctx.fillText(deltaText, 108, 932);
    ctx.textBaseline = "alphabetic";
  }

  ctx.strokeStyle = BORDER;
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(80, 1010);
  ctx.lineTo(W - 80, 1010);
  ctx.stroke();

  let y = 1080;
  const BADGE = 64;
  if (catsToShow.length === 0) {
    ctx.font = "500 36px 'Segoe UI', Arial, sans-serif";
    ctx.fillStyle = TXT2;
    ctx.fillText(t(lang, "noBairroActivity"), 80, y + 20);
  } else {
    catsToShow.forEach((cat, idx) => {
      const rowTop = y - BADGE / 2 + 6;
      const color = TONE_COLOR[cat.tone] || TONE_COLOR.neutral;
      ctx.fillStyle = color + "22";
      ctx.strokeStyle = color + "55";
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.roundRect(80, rowTop, BADGE, BADGE, 16);
      ctx.fill();
      ctx.stroke();
      const icon = catIcons[idx];
      if (icon) {
        const pad = 16;
        ctx.drawImage(icon, 80 + pad, rowTop + pad, BADGE - pad * 2, BADGE - pad * 2);
      }
      ctx.font = "600 38px 'Segoe UI', Arial, sans-serif";
      ctx.fillStyle = TXT2;
      ctx.textBaseline = "middle";
      ctx.fillText(cat.label, 80 + BADGE + 24, y + 4);
      ctx.font = "700 40px 'Segoe UI', Arial, sans-serif";
      ctx.fillStyle = TXT;
      ctx.textAlign = "right";
      ctx.fillText(String(cat.count), W - 80, y + 4);
      ctx.textAlign = "left";
      ctx.textBaseline = "alphabetic";
      y += BADGE + 18;
    });
  }

  const footerY = Math.min(H - 190, Math.max(1500, y + 90));
  ctx.fillStyle = SURFACE;
  ctx.beginPath();
  ctx.roundRect(80, footerY, W - 160, 130, 18);
  ctx.fill();
  ctx.strokeStyle = BORDER;
  ctx.stroke();
  ctx.font = "700 34px 'Segoe UI', Arial, sans-serif";
  ctx.fillStyle = TXT;
  ctx.fillText(t(lang, "shareCardFooterTitle"), 116, footerY + 56);
  ctx.font = "500 30px 'Segoe UI', Arial, sans-serif";
  ctx.fillStyle = AMBER;
  ctx.fillText("app.alertaal.com.br", 116, footerY + 98);

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
  if (!blob) return false;
  const file = new File([blob], `alerta-al-${stripAccentsMB(bairroName)}.png`, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: t(lang, "shareCardEyebrow"), text: t(lang, "shareCardShareText") });
      return true;
    } catch (e) {
      if (e && e.name === "AbortError") return true;
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `alerta-al-${stripAccentsMB(bairroName)}.png`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return true;
}

function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
  const words = text.split(" ");
  let line = "";
  let curY = y;
  for (let i = 0; i < words.length; i++) {
    const test = line ? `${line} ${words[i]}` : words[i];
    if (ctx.measureText(test).width > maxWidth && line) {
      ctx.fillText(line, x, curY);
      line = words[i];
      curY += lineHeight;
    } else {
      line = test;
    }
  }
  if (line) ctx.fillText(line, x, curY);
  return curY;
}

function BairroMiniMap({ lang, rings, color, pinItems }) {
  const mapDivRef = React.useRef(null);

  React.useEffect(() => {
    if (!mapDivRef.current) return;
    const map = L.map(mapDivRef.current, { zoomControl: true, scrollWheelZoom: true, touchZoom: true, attributionControl: false });
    L.tileLayer(window.VIGI_TILE_URL, window.VIGI_TILE_OPTIONS).addTo(map);
    const latlngRings = rings.map((ring) => ring.map(([lng, lat]) => [lat, lng]));
    const poly = L.polygon(latlngRings, {
      stroke: true, color: "rgba(255,255,255,0.4)", weight: 1,
      fillColor: color || "#243244", fillOpacity: color ? 0.55 : 0.18,
    }).addTo(map);
    map.fitBounds(poly.getBounds(), { padding: [14, 14], maxZoom: 16 });
    const offsets = window.spreadOverlappingPoints ? window.spreadOverlappingPoints(pinItems, (p) => p.lat, (p) => p.lng) : pinItems.map(() => [0, 0]);
    const badgeHtml = window.badgeHtml || ((text) => text);
    pinItems.forEach((p, idx) => {
      const [px, py] = offsets[idx];
      let icon, popupHtml;
      if (p.isNews) {
        icon = L.divIcon({
          className: "",
          html: `<div style="width:20px;height:20px;border-radius:6px;background:var(--color-brand-primary);border:2px solid #fff;box-shadow:var(--shadow-card);display:flex;align-items:center;justify-content:center;transform:translate(${px}px,${py}px)"><span style="display:inline-block;width:11px;height:11px;background-color:#fff;-webkit-mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/newspaper.svg');mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/newspaper.svg');-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;"></span></div>`,
          iconSize: [20, 20], iconAnchor: [10, 10],
        });
        const safeTitle = window.escapeHtml(p.title);
        const safeLink = /^https?:\/\//i.test(p.link || "") ? window.escapeHtml(p.link) : "#";
        popupHtml = `${badgeHtml(window.escapeHtml(p.outlet))}<br><b>${safeTitle}</b><br>${window.escapeHtml(p.bairro || "")}<br><a href="${safeLink}" data-link="${safeLink}" onclick="window.vigiOpenNewsArticle(this.getAttribute('data-link'));return false;" rel="noreferrer">${t(lang, "readFullArticleAt")} ${window.escapeHtml(p.outlet)} →</a>`;
      } else {
        const cat = (window.CATS || []).find((c) => c.id === p.category) || (window.CATS || []).find((c) => c.id === "outro");
        const toneColor = (window.TONE_COLOR || {})[cat ? cat.tone : "neutral"] || "#5C6B77";
        const iconUrl = window.catIconUrl ? window.catIconUrl(cat ? cat.icon : "more-horizontal") : "";
        icon = L.divIcon({
          className: "",
          html: `<div class="vigi-map-pin" style="background:${toneColor};transform:translate(${px}px,${py}px)"><span style="display:inline-block;width:11px;height:11px;background-color:#fff;-webkit-mask-image:url('${iconUrl}');mask-image:url('${iconUrl}');-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;"></span></div>`,
          iconSize: [20, 20], iconAnchor: [10, 10],
        });
        popupHtml = `${badgeHtml(t(lang, "sourceCommunity"))}<br><b>${cat ? t(lang, cat.key) : window.escapeHtml(p.category)}</b><br>${window.escapeHtml(p.bairro || "")}<br>${window.timeAgoLabel ? window.timeAgoLabel(p.createdAt, lang) : ""} · ${p.confirms || 0}`;
      }
      L.marker([p.lat, p.lng], { icon }).addTo(map).bindPopup(popupHtml);
    });
    return () => map.remove();
  }, []);

  return <div ref={mapDivRef} style={{ height: 150, borderRadius: 9, overflow: "hidden", position: "relative", zIndex: 0, border: "1px solid var(--color-border)", marginTop: 10 }} />;
}

function BairroReportCard({ lang, bairroName, reports, news, unlocked, onUnlock, onRemove, rings, rank }) {
  const { Button, Icon } = window.VigiALDesignSystem_ff2dec;
  const now = Date.now();
  const key = stripAccentsMB(bairroName);
  function inBairro(item) { return item.bairro && stripAccentsMB(item.bairro) === key; }
  const thisWeekReports = reports.filter((r) => inBairro(r) && now - r.createdAt <= MB_WEEK_MS);
  const lastWeekReports = reports.filter((r) => inBairro(r) && now - r.createdAt > MB_WEEK_MS && now - r.createdAt <= MB_WEEK_MS * 2);
  const thisWeekNews = news.filter((n) => inBairro(n) && n.publishedAt && now - n.publishedAt <= MB_WEEK_MS);
  const lastWeekNews = news.filter((n) => inBairro(n) && n.publishedAt && now - n.publishedAt > MB_WEEK_MS && now - n.publishedAt <= MB_WEEK_MS * 2);
  const thisTotal = thisWeekReports.length + thisWeekNews.length;
  const lastTotal = lastWeekReports.length + lastWeekNews.length;
  const delta = thisTotal - lastTotal;
  const catCounts = {};
  [...thisWeekReports, ...thisWeekNews].forEach((item) => {
    const cat = item.category || "outro";
    catCounts[cat] = (catCounts[cat] || 0) + 1;
  });
  const catRanked = Object.entries(catCounts).sort((a, b) => b[1] - a[1]);
  const heatColor = rank != null && window.rankToColor ? window.rankToColor(rank) : null;
  const pinItems = [
    ...thisWeekReports.filter((r) => r.lat != null).map((r) => ({ ...r, isNews: false })),
    ...thisWeekNews.filter((n) => n.lat != null).map((n) => ({ ...n, isNews: true })),
  ];
  const [sharing, setSharing] = React.useState(false);
  async function handleShare() {
    setSharing(true);
    const topCats = catRanked.slice(0, 4).map(([catId, count]) => {
      const cat = (window.CATS || []).find((c) => c.id === catId);
      return {
        label: cat ? t(lang, cat.key) : catId, count,
        icon: cat ? cat.icon : "more-horizontal", tone: cat ? cat.tone : "neutral",
      };
    });
    try {
      await shareBairroCard({ bairroName, thisTotal, delta, lastTotal, topCats, lang });
    } catch (e) {}
    setSharing(false);
  }

  return (
    <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, marginBottom: 10, position: "relative" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
        <span style={{ fontSize: "var(--text-base)", fontWeight: 600 }}>{bairroName}</span>
        <button onClick={onRemove} title={t(lang, "deletePlaceConfirm")} style={{ background: "transparent", border: "none", cursor: "pointer", padding: 2, display: "flex" }}>
          <Icon name="trash-2" size={15} color="var(--color-text-muted)" />
        </button>
      </div>
      {!unlocked ? (
        <div style={{ textAlign: "center", padding: "12px 8px" }}>
          <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8 }}>{t(lang, "reportLockedHint")}</div>
          <Button variant="secondary" size="sm" onClick={onUnlock} icon={(p) => <Icon name="play-circle" size={13} {...p} />}>{t(lang, "watchAdToUnlock")}</Button>
        </div>
      ) : (
        <div>
          <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginBottom: 8 }}>
            <span style={{ fontSize: 22, fontWeight: 700, color: "var(--color-text-primary)" }}>{thisTotal}</span>
            <span style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "occurrencesThisWeek")}</span>
            {lastTotal > 0 && (
              <span style={{ fontSize: "var(--text-xs)", fontWeight: 600, marginLeft: "auto", color: delta > 0 ? "var(--color-alert)" : delta < 0 ? "var(--color-brand-primary)" : "var(--color-text-muted)" }}>
                {delta > 0 ? "▲" : delta < 0 ? "▼" : "—"} {Math.abs(delta)} {t(lang, "vsLastWeek")}
              </span>
            )}
          </div>
          {catRanked.length === 0 ? (
            <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "noBairroActivity")}</div>
          ) : (
            catRanked.map(([catId, count]) => {
              const cat = (window.CATS || []).find((c) => c.id === catId);
              return (
                <div key={catId} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "var(--text-xs)", padding: "5px 0", borderTop: "1px solid var(--color-border)" }}>
                  <span style={{ color: "var(--color-text-secondary)" }}>{cat ? t(lang, cat.key) : catId}</span>
                  <span style={{ fontFamily: "var(--font-mono)", color: "var(--color-text-muted)" }}>{count}</span>
                </div>
              );
            })
          )}
          {thisWeekNews.length > 0 && (
            <div style={{ marginTop: 8 }}>
              {thisWeekNews.slice(0, 3).map((n) => (
                <div key={n.link} style={{ fontSize: "var(--text-xs)", padding: "6px 0", borderTop: "1px solid var(--color-border)" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                    <span style={{ fontWeight: "var(--weight-semibold)", color: "var(--color-brand-deep)", background: "var(--color-brand-tint)", borderRadius: "var(--radius-pill)", padding: "1px 6px", flexShrink: 0 }}>{n.outlet}</span>
                    <span style={{ color: "var(--color-text-muted)", fontFamily: "var(--font-mono)", marginLeft: "auto", flexShrink: 0 }}>{window.timeAgoLabel(n.publishedAt, lang)}</span>
                  </div>
                  <a href={n.link} target="_blank" rel="noreferrer" style={{ color: "var(--color-text-secondary)", textDecoration: "none" }}>{n.title}</a>
                </div>
              ))}
            </div>
          )}
          {rings && <BairroMiniMap lang={lang} rings={rings} color={heatColor} pinItems={pinItems} />}
          <Button variant="secondary" size="sm" onClick={handleShare} disabled={sharing} icon={(p) => <Icon name="share-2" size={13} {...p} />} style={{ width: "100%", marginTop: 10 }}>
            {sharing ? t(lang, "shareCardGenerating") : t(lang, "shareCardBtn")}
          </Button>
        </div>
      )}
    </div>
  );
}

function MeuBairroScreen({ lang }) {
  const { Button, Icon } = window.VigiALDesignSystem_ff2dec;
  const [premium, setPremiumFlag] = React.useState(() => (window.isPremium ? window.isPremium() : false));
  const [myBairros, setMyBairros] = React.useState(loadMyBairros);
  const [bairroGeo, setBairroGeo] = React.useState({});
  const [bairroPolygons, setBairroPolygons] = React.useState({});
  const [bairroNames, setBairroNames] = React.useState([]);
  const [reports, setReports] = React.useState([]);
  const [news, setNews] = React.useState([]);
  const [adding, setAdding] = React.useState(false);
  const [draftBairro, setDraftBairro] = React.useState("");
  const [unlockedWeeks, setUnlockedWeeks] = React.useState(loadUnlockedWeeks);
  const [showAd, setShowAd] = React.useState(false);

  const limit = premium ? PREMIUM_BAIRRO_LIMIT : FREE_BAIRRO_LIMIT;
  const weekKey = React.useMemo(() => isoWeekKey(new Date()), []);
  const isUnlocked = premium || !!unlockedWeeks[weekKey];

  React.useEffect(() => {
    fetch("bairro_polygons.json")
      .then((r) => r.json())
      .then((data) => {
        const geo = {};
        Object.entries(data).forEach(([name, rings]) => { geo[name] = bboxCenterAndRadius(rings[0]); });
        setBairroGeo(geo);
        setBairroPolygons(data);
        setBairroNames(Object.keys(data).sort((a, b) => a.localeCompare(b, "pt")));
      })
      .catch(() => {});
  }, []);

  React.useEffect(() => {
    fetch(`${MB_API_BASE}/reports?window=90d`).then((r) => r.json()).then(setReports).catch(() => {});
    fetch(`${MB_API_BASE}/news?window=90d`).then((r) => r.json()).then(setNews).catch(() => {});
  }, []);

  React.useEffect(() => {
    if (Object.keys(bairroGeo).length) persistBairroPlaces(myBairros, bairroGeo);
  }, [myBairros, bairroGeo]);

  function handleAdd() {
    if (!draftBairro || myBairros.includes(draftBairro)) { setAdding(false); return; }
    const updated = [...myBairros, draftBairro];
    setMyBairros(updated);
    saveMyBairros(updated);
    setAdding(false);
    setDraftBairro("");
  }
  function handleRemove(name) {
    const updated = myBairros.filter((b) => b !== name);
    setMyBairros(updated);
    saveMyBairros(updated);
  }
  function handleAdClose() {
    setShowAd(false);
    const updated = { ...unlockedWeeks, [weekKey]: true };
    setUnlockedWeeks(updated);
    saveUnlockedWeeks(updated);
  }

  // Same green-to-red percentile ranking the map's heatmap uses. Ranked
  // over the full 90-day fetch rather than just this week: with so few
  // in-app reports and most news coverage older than 7 days, a week-only
  // sample was too thin to rank on — a bairro with well-documented recent
  // violent crime (just not literally in the last 7 days) could still come
  // out green. The "X ocorrências esta semana" count below stays weekly on
  // purpose — that one's meant to answer "what's fresh", not "how risky".
  const weekRankByKey = React.useMemo(() => {
    if (!window.computeBairroRanks) return {};
    const allBairroKeys = Object.keys(bairroPolygons).map(stripAccentsMB);
    return window.computeBairroRanks([...reports, ...news], allBairroKeys, Date.now()).rankByKey;
  }, [reports, news, bairroPolygons]);

  return (
    <div style={{ padding: 14, flex: 1, overflowY: "auto" }}>
      <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 10 }}>{t(lang, "meuBairroIntro")}</div>

      {myBairros.length === 0 && !adding && (
        <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-muted)", marginBottom: 10 }}>{t(lang, "noBairrosYet")}</div>
      )}

      {myBairros.map((name) => (
        <BairroReportCard
          key={name} lang={lang} bairroName={name} reports={reports} news={news}
          unlocked={isUnlocked} onUnlock={() => setShowAd(true)} onRemove={() => handleRemove(name)}
          rings={bairroPolygons[name]} rank={weekRankByKey[stripAccentsMB(name)]}
        />
      ))}

      {adding ? (
        <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 10, marginTop: 4 }}>
          <select
            value={draftBairro}
            onChange={(e) => setDraftBairro(e.target.value)}
            style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 8, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: 10 }}
          >
            <option value="">{t(lang, "selectBairro")}</option>
            {bairroNames.filter((n) => !myBairros.includes(n)).map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
          <div style={{ display: "flex", gap: 8 }}>
            <Button variant="ghost" onClick={() => { setAdding(false); setDraftBairro(""); }} style={{ flex: 1 }}>{t(lang, "cancel")}</Button>
            <Button variant="primary" onClick={handleAdd} disabled={!draftBairro} style={{ flex: 1 }}>{t(lang, "saveBairro")}</Button>
          </div>
        </div>
      ) : myBairros.length < limit ? (
        <Button variant="secondary" onClick={() => setAdding(true)} style={{ width: "100%" }} icon={(p) => <Icon name="plus" size={14} {...p} />}>
          {t(lang, "addBairro")}
        </Button>
      ) : !premium ? (
        <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, textAlign: "center" }}>
          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 10 }}>{t(lang, "freeLimitReachedBairro")}</div>
          <Button variant="primary" onClick={() => { if (window.changeTab) window.changeTab("perfil"); }} style={{ width: "100%" }}>
            {t(lang, "upgradeButton")}
          </Button>
        </div>
      ) : null}

      {premium && (
        <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginTop: 10, textAlign: "center" }}>{t(lang, "premiumBairroNote")}</div>
      )}

      {showAd && <window.InterstitialAd lang={lang} onClose={handleAdClose} />}
    </div>
  );
}
window.MeuBairroScreen = MeuBairroScreen;
